import React from 'react'
import { PaymentMethod } from './PaymentMethod'

export const Payment = (props) => {

	const handlePayment = (method, price, bool) => {
		return props.handleUpdate({
			...props.bestellung,
			contact: {
				...props.bestellung.contact,
				[props.client]: {
					...props.bestellung.contact[props.client],
					payment: {
						method: method,
						price: price,
						clientId: bool
					}
				}
			}
		})
	}

	return (
		<div className="no__payment-container">
			<h3>Zahlungsmethode</h3>
			<div className='no__paymentmethods'>
				{
					props.settings.bezahlung.map((payment, index) => {
						return <PaymentMethod
							key={payment + index}
							contact={props.bestellung.contact}
							method={payment}
							handlePayment={handlePayment}
							region={props.region}
							settings={props.settings}
							active={props.active}
							client={props.client}			
						/>
				})
				}
			</div>
		</div>
	)
}
